import { useParams } from "react-router-dom";
import HistoryStatus from "./HistoryStatus";
import DownloadLaporan from "./DownloadLaporan";
import { chain } from "lodash";
import { useFetchTrackingById, useFetchTrackingEvents } from "../hooks/use-queries";
import { dateFormat, rupiahFormat } from "../utils/format";
import { EventTracking } from "./EventTracking";
import { EventTrackingMatched } from "./EventTrackingMatched";

export default function DetailTransaksi(props) {
  const { id } = useParams();
  const { data: eventData } = useFetchTrackingEvents(id);
  const { data: trackingData } = useFetchTrackingById(id);
  const hasOrderDetail = eventData?.some(event => event.meta?.order_detail_id);

  const productCount = trackingData?.meta?.details?.length || 0;
  const cuttingPlanEvents = chain(eventData)
    .filter({ type: "CUTTING PLAN" })
    .orderBy("created_at", "desc")
    .uniqBy((obj) => obj.meta.neats_number)
    .orderBy((obj) => obj.meta.neats_number, "desc")
    .take(productCount)
    .value();

  const getDetailNames = (names) => {
    if (Array.isArray(names)) {
      return names;
    }

    if (typeof names === "string" || typeof names === "number") {
      return [names];
    }

    if (names && typeof names === "object") {
      return Object.keys(names)
        .sort((firstKey, secondKey) => Number(firstKey) - Number(secondKey))
        .map((key) => names[key])
        .filter(Boolean);
    }

    return [];
  };

  return (
    <>
      <div>
        <div>
          <h1 className="font-Rubik font-medium text-[#787878] text-[16px]">Status Qurban </h1>
          <div className="bg-[#82BE41] h-[3px] w-[80px] rounded-[5px] mt-2"></div>
        </div>
        <HistoryStatus id={id} />
      </div>
      <div>
        <div>
          <h1 className="font-Rubik font-medium text-[#787878] text-[16px] mt-4">Data Transaksi </h1>
          <div className="bg-[#82BE41] h-[3px] w-[80px] rounded-[5px] mt-2"></div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 mt-8 font-Rubik text-base sm:text-[15px] font-semibold text-[#787878]">
        <div className="text-center">
          <div className="bg-[#F5F5F5] py-1 font-light">
            <h3>Nomor Transaksi</h3>
          </div>
          <h3 className="my-4 max-w-[200px] mx-auto">{trackingData?.meta?.identification_number}</h3>
        </div>
        <div className=" text-center">
          <div className="bg-[#F5F5F5] py-1 font-light">
            <h3>Nama Donatur</h3>
          </div>
          <h3 className="my-4 max-w-[200px] mx-auto">{trackingData?.meta?.name}</h3>
        </div>
        <div className=" text-center">
          <div className="bg-[#F5F5F5] py-1 font-light">
            <h3>Tanggal Transaksi</h3>
          </div>
          <h3 className="my-4 max-w-[200px] mx-auto ">{dateFormat(trackingData?.meta?.payment_date)}</h3>
        </div>
        <div className="text-center">
          <div className="bg-[#F5F5F5] py-1 font-light">
            <h3>Total Pembayaran</h3>
          </div>
          <h3 className="my-4 max-w-[200px] mx-auto ">{rupiahFormat(trackingData?.meta?.amount)}</h3>
        </div>
      </div>
      {
        !hasOrderDetail ? (
          <EventTracking
            trackingDetails={trackingData?.meta?.details} 
            cuttingPlanEvents={cuttingPlanEvents}
          />
        ) : (
          <EventTrackingMatched
            trackingDetails={trackingData?.meta?.details} 
            cuttingPlanEvents={cuttingPlanEvents}
          />
        )
      }

      <DownloadLaporan id={id} />
      <div>
        <h1 className="font-Rubik font-medium text-[#787878] text-[16px] mt-8 sm:mt-4">Data Pekurban </h1>
        <div className="bg-[#82BE41] h-[3px] w-[80px] rounded-[5px] mt-2"></div>
      </div>
      <div>
        <div className="flex mt-8 font-Rubik text-sm font-normal sm:text-base text-[#787878]">
          <div className="flex flex-wrap gap-2">
            {trackingData?.meta?.details.map((detail, index) => (
              <div key={index + 1} className="flex flex-wrap gap-2">
                {getDetailNames(detail.names).map((name, nameIndex) => (
                  <h4 key={`${index + 1}-${nameIndex + 1}`} className="py-2 px-8 border-[1.5px] border-[#84db00] bg-[#E6F8CC] rounded-[50px]">
                    {name}
                  </h4>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
